import bugsnag from 'bugsnag-js'

import React from 'react'
import createPlugin from 'bugsnag-react'

export const bugsnagClient = bugsnag('e0244e9cfc62adf210eb0247b8b87ffe')

export const ErrorBoundary = bugsnagClient.use(createPlugin(React))
